// extracted by mini-css-extract-plugin
export default {"badge":"styles_badge__8DVI1","modal":"styles_modal__Qajlo","actions":"styles_actions__ZFn-c"};